import { render } from "./OnDemandValidations.vue?vue&type=template&id=18bd531e"
import script from "./OnDemandValidations.vue?vue&type=script&lang=js"
export * from "./OnDemandValidations.vue?vue&type=script&lang=js"

import "./OnDemandValidations.vue?vue&type=style&index=0&id=18bd531e&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__